import { animationDelayMs, getUuid } from '../../utils'
import { ottRoot } from '../Api'
import { ILightRailItem } from '../../types'

import { asset_type_enum } from '../types'

let reloadPageTimeout: NodeJS.Timeout
export const ottUtils = (() => {
  return {
    getLevels: (asPath: string) => {
      let levelsObjString = ''
      levelsObjString += '{'
      levelsObjString += '"page_1_level_eng" : "main",'
      ottUtils
        .getCleanUrl(asPath)
        .split('/')
        .map((level, index) => {
          if (level) {
            levelsObjString += `"page_${index + 1}_level_eng" : "${level}",`
          }
        })
      levelsObjString += '}'
      const correctedString = levelsObjString.replace(/,}/g, '}')
      return JSON.parse(correctedString)
    },

    getCleanUrl: (asPath: string): string => {
      return asPath.split('?')[0].split('#')[0]
    },

    getArrayLevels: (asPath: string) => {
      const levelsArr: string[] = []
      ottUtils
        .getCleanUrl(asPath)
        .split('/')
        .map(level => {
          if (level) {
            levelsArr.push(level)
          }
        })
      return levelsArr
    },

    getPageId: (asPath: string, page_id?: number | null) => {
      if (ottUtils.getArrayLevels(asPath)[1] === 'screen') {
        return parseInt(asPath.split('/')[asPath.split('/').length - 2])
      }
      if (ottUtils.getArrayLevels(asPath)[3] === 'season') {
        return null
      }
      if (page_id) {
        return page_id
      }
      return null
    },

    getPageType: (
      asPath: string,
      typeFromPlayer?: string,
      eventType?: string
    ) => {
      const levels = ottUtils.getArrayLevels(asPath)
      if (!levels[1]) {
        return 'screen'
      }
      if (eventType === 'page' && levels[3] === 'season') {
        return 'episode'
      }
      if (eventType === 'page' && levels[1] === 'series') {
        return 'series'
      }
      if (typeFromPlayer) {
        return typeFromPlayer.toLowerCase()
      }
      return levels[1]
    },

    getPageData: ({
      asPath,
      eventType,
      pageTitle,
      page_type,
      page_id,
    }: {
      asPath: string
      eventType?: string
      pageTitle?: string
      page_type?: string
      page_id?: number | null
    }) => {
      return {
        levels: ottUtils.getLevels(asPath),
        page_id: ottUtils.getPageId(asPath, page_id),
        page_url: window.location.href,
        page_type: ottUtils.getPageType(asPath, page_type, eventType),
        clean_page_url: window.location.href.split('?')[0],
        canonical_url: window.location.href.split('?')[0],
        page_title: pageTitle,
        cd_reshet_id: getUuid(),
      }
    },

    getVideoDurationInSeconds: (duration: string | number): number => {
      if (typeof duration === 'string') {
        const durationArray = duration.split(':').reverse()
        const mapArr = [0, 60, 360]
        let totalDuration = 0
        durationArray.map((value, index) => {
          totalDuration += parseInt(value) * mapArr[index]
        })
        return totalDuration
      }
      return duration
    },
    getAssetPath(data: ILightRailItem) {
      const path: (string | number)[] = [ottRoot]
      switch (data.type) {
        case asset_type_enum.Series:
          path.push('series')
          if (data.metas.SeriesID) {
            path.push(data.metas.SeriesID)
          } else {
            path.push(data.externalId.split('-')[1])
          }
          break
        case asset_type_enum.Episodes:
          path.push('series')
          path.push(data.metas.SeriesID || '')
          path.push('season')
          path.push(data.metas.SeasonNumber)
          path.push(data.id)
          break
        default:
          path.push(data.id)
      }
      return path.join('/')
    },
    autoRefresh: ({ videoPlaying }: { videoPlaying: boolean }) => {
      const haseTerrific = !!document.querySelector('#terrific-timeline-div')
      reloadPageTimeout && clearTimeout(reloadPageTimeout)
      if (!videoPlaying && !haseTerrific) {
        reloadPageTimeout = setTimeout(() => {
          const haseTerrific = !!document.querySelector(
            '#terrific-timeline-div'
          )
          if (!videoPlaying && !haseTerrific) {
            window.location.reload()
          }
        }, animationDelayMs.sevenMinutes)
      }
    },
  }
})()
